export default {
    resend_dealer_alert_log_title: "Reenviar Alerta al Webhook",
    resend_dealer_alert_log_description: "¿Está seguro de que desea reenviar esta alerta al webhook configurado?",
    resend_dealer_alert_log_log_id: "ID de Registro",
    resend_dealer_alert_log_timestamp: "Fecha/Hora",
    resend_dealer_alert_log_resend: "Reenviar",
    resend_dealer_alert_log_success: "Alerta reenviada exitosamente al webhook",
    resend_dealer_alert_log_error: "Falló el reenvío de la alerta al webhook. Por favor, verifique si el webhook está inactivo, fue eliminado o está mal configurado.",
};
